import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const BASE_URL = "http://103.235.105.54/admin/api/";

const Bill = () => {
  const { order_id } = useParams();
  const [order, setOrder] = useState(null);
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");

  // ✅ Redirect to login if no token
  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [token, navigate]);

  // ✅ Fetch bill data
  useEffect(() => {
    if (token) {
      fetch(`${BASE_URL}generate-bill/${order_id}`)
        .then((res) => res.json())
        .then((data) => setOrder(data))
        .catch((err) => console.error("Fetch error:", err));
    }
  }, [order_id, token]);

  // ✅ Automatically open print dialog when bill loads
  useEffect(() => {
    if (order) {
      const timer = setTimeout(() => {
        window.print();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [order]);

  if (!order) return <div>Loading bill...</div>;

  const { bill, order_items, totals } = order;

  // ✅ Manual print and close functions
  const handlePrint = () => {
    window.print();
  };

  const handleClose = () => {
    navigate("/table");
  };

  return (
    <div
      style={{
        width: "80mm",
        padding: "5px",
        fontFamily: "monospace",
        fontSize: "12px",
        margin: "0 auto",
      }}
    >
      <center>
        <h3>My Company</h3>
        <p>GSTIN: 1234567890</p>
        <p>----------------------------------------</p>
      </center>

      <div>
        <p>
          <strong>Invoice No:</strong> {bill.invoice_number}
          <br />
          <strong>Order ID:</strong> {bill.order_id}
          <br />
          <strong>Date:</strong> {new Date(bill.sales_at).toLocaleString()}
        </p>
      </div>

      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th align="left">Item</th>
            <th align="right">Qty</th>
            <th align="right">Amt</th>
          </tr>
        </thead>
        <tbody>
          {order_items.map((item, idx) => (
            <tr key={idx}>
              <td>{item.item_name}</td>
              <td align="right">{item.qty}</td>
              <td align="right">{parseFloat(item.netprice).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p>----------------------------------------</p>

      <div style={{ textAlign: "right" }}>
        <p>
          <strong>Subtotal:</strong> ₹
          {parseFloat(totals?.total_netprice - totals?.total_tax || 0).toFixed(2)}
        </p>
        <p>
          <strong>CGST:</strong> ₹
          {parseFloat(totals?.total_tax / 2 || 0).toFixed(2)}
        </p>
        <p>
          <strong>SGST:</strong> ₹
          {parseFloat(totals?.total_tax / 2 || 0).toFixed(2)}
        </p>
        <p>
          <strong>Discount:</strong> ₹
          {parseFloat(totals?.total_net_amount - totals?.total_netprice || 0).toFixed(2)}
        </p>
        <p>
          <strong>Grand Total:</strong> ₹
          {parseFloat(totals?.total_net_amount || 0).toFixed(2)}
        </p>
      </div>

      <p>----------------------------------------</p>
      <center>
        <p>Thank You! Visit Again</p>
      </center>

      {/* ✅ Print & Close Buttons */}
      <div
        className="no-print"
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          marginTop: "10px",
        }}
      >
        <button
          onClick={handlePrint}
          style={{
            padding: "5px 10px",
            background: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          🖨️ Print
        </button>

        <button
          onClick={handleClose}
          style={{
            padding: "5px 10px",
            background: "#dc3545",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          ❌ Close
        </button>
      </div>

      {/* ✅ Hide buttons in print mode */}
      <style>
        {`
          @media print {
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Bill;
